<template>
  <div class="queued-indicator">
    <div class="queued-header" @click="expanded = !expanded">
      <i class="fas fa-clock queued-icon"></i>
      <span class="queued-label">
        {{ queue.length }} message{{ queue.length > 1 ? "s" : "" }} queued
      </span>
      <button
        class="queued-action-btn"
        :title="paused ? 'Resume queue' : 'Pause queue'"
        @click.stop="$emit('toggle-pause')"
      >
        <i :class="paused ? 'fas fa-play' : 'fas fa-pause'"></i>
      </button>
      <i
        class="fas queued-chevron"
        :class="expanded ? 'fa-chevron-down' : 'fa-chevron-right'"
      ></i>
    </div>

    <div v-show="expanded" class="queued-body">
      <div v-for="(item, index) in queue" :key="index" class="queued-item">
        <i class="fas fa-circle queued-item-dot"></i>
        <span class="queued-item-text">{{ item.text || "(attachment)" }}</span>
        <button
          class="queued-action-btn queued-action-btn--danger"
          title="Remove"
          @click.stop="$emit('remove', index)"
        >
          <i class="fas fa-trash"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QueuedMessageIndicator",
  props: {
    queue: {
      type: Array,
      required: true,
    },
    paused: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["remove", "toggle-pause"],
  data() {
    return {
      expanded: true,
    };
  },
  watch: {
    "queue.length"(newLen, oldLen) {
      if (newLen > oldLen) {
        this.expanded = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.queued-indicator {
  margin: 0 20px 6px;
  background: var(--oliver-indicator-bg);
  border: 1px solid var(--oliver-indicator-border);
  border-radius: 10px;
  overflow: hidden;
  animation: fadeIn 0.2s ease;
  flex-shrink: 0;
}

.queued-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  cursor: pointer;
  user-select: none;
  transition: background 0.15s ease;

  &:hover {
    background: var(--oliver-btn-subtle-hover);
  }
}

.queued-icon {
  font-size: 12px;
  color: var(--oliver-accent);
  flex-shrink: 0;
}

.queued-label {
  font-size: 12px;
  font-weight: 500;
  color: var(--oliver-text);
  flex: 1;
}

.queued-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: var(--oliver-text-muted);
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s ease, color 0.15s ease;

  i {
    font-size: 10px;
  }

  &:hover {
    background: var(--oliver-btn-subtle-hover);
    color: var(--oliver-accent);
  }

  &--danger:hover {
    background: rgba(229, 62, 62, 0.1);
    color: #e53e3e;
  }
}

.queued-chevron {
  font-size: 10px;
  color: var(--oliver-text-muted);
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.queued-body {
  border-top: 1px solid var(--oliver-border);
  padding: 4px 0;
}

.queued-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;

  &:not(:last-child) {
    border-bottom: 1px solid var(--oliver-border);
  }
}

.queued-item-dot {
  font-size: 5px;
  color: var(--oliver-text-muted);
  flex-shrink: 0;
}

.queued-item-text {
  font-size: 12px;
  color: var(--oliver-text-muted);
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
